module.exports = __webpack_public_path__ + "img/1 (73).424f3776.png";